import { render, staticRenderFns } from "./BudgetInstances.vue?vue&type=template&id=4ef72a3b&scoped=true"
import script from "./BudgetInstances.vue?vue&type=script&lang=js"
export * from "./BudgetInstances.vue?vue&type=script&lang=js"
import style0 from "./BudgetInstances.vue?vue&type=style&index=0&id=4ef72a3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef72a3b",
  null
  
)

export default component.exports